import { User } from 'iconsax-react'
import React, { useEffect, useState } from 'react'

import type { TPlan } from '@/store/api/Users/Users.types'
import { SocialMirrorPalette } from '@/utils/palette/SocialMirrorPalette'

import { Chip } from '../Chip/Chip'

interface PhotoSelectorProps {
  initialImageUrl: string
  fullname: string
  plan?: TPlan | null
}

export const PhotoSelector = ({
  fullname,
  plan,
  initialImageUrl,
}: PhotoSelectorProps) => {
  const [displayUrl, setDisplayUrl] = useState<string>(initialImageUrl)
  const [isError, setIsError] = useState<boolean>(false)

  useEffect(() => {
    setDisplayUrl(initialImageUrl)
  }, [initialImageUrl])

  useEffect(() => {
    return () => {
      if (displayUrl && displayUrl.startsWith('blob:')) {
        URL.revokeObjectURL(displayUrl)
      }
    }
  }, [displayUrl])

  return (
    <div className="w-full flex items-center">
      <div className="flex flex-row items-center gap-6 rounded-lg bg-baseColorHighlight w-full">
        <div className="flex-shrink-0">
          <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-neutralColor30">
            {displayUrl !== '' && displayUrl !== null && !isError ? (
              <img
                alt="Profile"
                src={displayUrl}
                className="w-full h-full object-cover"
                onError={() => {
                  setIsError(true)
                }}
              />
            ) : (
              <div className="w-full h-full bg-baseColor flex items-end justify-center mt-1">
                <User
                  size={54}
                  color={SocialMirrorPalette.neutralColor30}
                  variant="Bold"
                />
              </div>
            )}
          </div>
        </div>

        <div className="flex-1 flex flex-col gap-1">
          <h3 className="text-lg font-medium text-white">{fullname}</h3>

          <div className="flex flex-row gap-2">
            {plan && plan.isActive && (
              <Chip variant="blue" size="tag" text={plan.name} />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
